// extracted by mini-css-extract-plugin
module.exports = {"error":"errorBoundary_error__J3gSZ","message":"errorBoundary_message__WUxmH","reason":"errorBoundary_reason__1Ovan","icon":"errorBoundary_icon__mITv4"};